/** Unauthenticated public pages — must not require ERP login or module scope. */
const PUBLIC_ANONYMOUS_PREFIXES = [
  '/careers',
  '/candidate-portal',
  '/embed/lead',
  '/pos/display',
] as const;

export function isPublicAnonymousRoute(pathname: string): boolean {
  const path = (pathname.split('?')[0] || '').toLowerCase();
  return PUBLIC_ANONYMOUS_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
